@if (hasDecorativeBoards()) {
  <div class="config-container shadow mt-4">
    <h4
      (click)="toggleCollapse(SubStepEnum.DecorativeBoards)"
      [ngClass]="{ active: subStep === SubStepEnum.DecorativeBoards }"
      class="title configurator-subtitle collapse-button">
      <span>{{ 'fence.materials.decorative-boards' | translate }}</span>
      <span class="title-count">{{ decorativeBoards?.length }} {{ 'fence.materials.available-decorative-boards' | translate }}</span>
    </h4>
    @if (!configuration.hasValidQuotation && !isDecorativeBoardsValid) {
      <span class="disabled-product pt-1 ml-4">{{ disableMessage }}</span>
    }

    @if (configuration.hasValidQuotation && !isDecorativeBoardsValid) {
      <span class="disabled-with-quotation-product pt-1 ml-4">{{ 'fence.materials.valid-quotation-message' | translate }}</span>
    }

    @if (subStep === SubStepEnum.DecorativeBoards) {
      <div class="collapse-block">
        <div class="decoration-form-row">
          <div class="decoration-form-group">
            <ng-fence-side-panel-count></ng-fence-side-panel-count>
          </div>
        </div>
        <button (click)="deleteAllDecorativeBoards()" class="decoration-delete">
          {{ 'fence.materials.delete-decorations' | translate }}
        </button>
        <div class="decoration-container">
          @for (decorativeBoard of decorativeBoards; track decorativeBoard.id) {
            <div [ngClass]="{disabled: decorativeBoard.isDisabled}" class="decoration-card">
              <img [src]="baseImgURL + decorativeBoard.icon" alt="decorative-board-img" class="decoration-img" />
              <div class="decoration-content">
                @if (currentLang === 'fr') {
                  <p class="decoration-title">{{ decorativeBoard.nameFr }}</p>
                } @else {
                  <p class="decoration-title">{{ decorativeBoard.nameEn }}</p>
                }

                <!-- Horizontal -->
                @if (hasHorizontalDecorativeBoards() && decorativeBoard.canBeHorizontal) {
                  <div class="decoration-form-row">
                    <div class="decoration-form-group">
                      <input
                        (change)="addDecorativeBoard('horizontal', decorativeBoard)"
                        [checked]="isDecorativeBoardChecked('horizontal', decorativeBoard)"
                        [id]="'decorative-board' + decorativeBoard.id + 'horizontal'"
                        type="checkbox" />
                      <label [for]="'decorative-board' + decorativeBoard.id + 'horizontal'">{{
                          'fence.materials.horizontal' | translate
                        }}</label>
                    </div>
                    <div class="decoration-form-group form-row">
                      <div class="form-label">
                        <label [for]="'decorative-board' + decorativeBoard.id + 'horizontal_qty'">{{
                            'fence.materials.quantity' | translate
                          }}</label>
                      </div>
                      <div class="form-input">
                        <input
                          (change)="changeDecorativeBoardQuantity('horizontal', decorativeBoard, null, $event)"
                          [disabled]="!isDecorativeBoardChecked('horizontal', decorativeBoard)"
                          [id]="'decorative-board' + decorativeBoard.id + 'horizontal_qty'"
                          [max]="maxHorizontalElement(decorativeBoard)"
                          [value]="getDecorativeBoardQuantity('horizontal', decorativeBoard, null)"
                          autocorrect="off"
                          min="0"
                          spellcheck="false"
                          type="number" />
                      </div>
                    </div>
                  </div>
                }

                <!-- Vertical -->
                @if (hasVerticalDecorativeBoards() && decorativeBoard.canBeVertical) {
                  <div class="decoration-form-row">
                    <div class="decoration-form-group">
                      <input
                        (change)="addDecorativeBoard('vertical', decorativeBoard)"
                        [checked]="isDecorativeBoardChecked('vertical', decorativeBoard)"
                        [id]="'decorative-board' + decorativeBoard.id + 'vertical'"
                        type="checkbox" />
                      <label [for]="'decorative-board' + decorativeBoard.id + 'vertical'">{{
                          'fence.materials.vertical' | translate
                        }}</label>
                    </div>
                    <div class="decoration-form-group form-row">
                      <div class="form-label">
                        <label [for]="'decorative-board' + decorativeBoard.id + 'vertical_qty'">{{
                            'fence.materials.total-quantity' | translate
                          }}</label>
                      </div>
                      <div class="form-input">
                        <input
                          [disabled]="true"
                          [id]="'decorative-board' + decorativeBoard.id + 'vertical_qty'"
                          [value]="getDecorativeBoardQuantity('vertical', decorativeBoard, null)"
                          autocorrect="off"
                          min="0"
                          spellcheck="false"
                          type="number" />
                      </div>
                    </div>
                  </div>
                }

                @if (isDecorativeBoardChecked('vertical', decorativeBoard)) {
                  <div class="decoration-form-row justify-content-end">
                    <div class="decoration-form-group">
                      @for (side of configuration.sides; track side.id) {
                        <div class="decoration-form-group form-row mb-2 pr-0">
                          <div class="form-label">
                            <label [for]="'decorative-board' + side.id + '_' + decorativeBoard + 'vertical_qty'">
                              {{ 'fence.materials.side' | translate }} {{ side.id }}
                            </label>
                          </div>
                          <div class="form-input">
                            <input
                              (change)="changeDecorativeBoardQuantity('vertical', decorativeBoard, side.id, $event)"
                              [disabled]="!isDecorativeBoardChecked('vertical', decorativeBoard) || maxVerticalElement(decorativeBoard, side) <= 0"
                              [id]="'decorative-board' + side.id + '_' + decorativeBoard.id + 'vertical_qty'"
                              [max]="maxVerticalElement(decorativeBoard, side)"
                              [value]="getDecorativeBoardQuantity('vertical', decorativeBoard, side)"
                              autocorrect="off"
                              min="0"
                              spellcheck="false"
                              type="number" />
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          } @empty {
            <ng-casto-loader></ng-casto-loader>
          }
        </div>
      </div>
    }
  </div>
}
